import { useTranslation } from 'next-i18next';
import { Divider, Input, Spacing, TextField } from '@zep/ui';
import { usePlanPaymentFormContext } from '../../PlanPaymentSection/Providers';
import { PlanTemplateType } from '../../types';
import { PaypleCardRegisterSection } from './PaypleCardRegisterSection';
export const PlanPaymentForeignMethod = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    watch,
    register
  } = usePlanPaymentFormContext();
  const planTemplateType = watch('planTemplateType');
  return <>
      <Spacing size={32} data-sentry-element="Spacing" data-sentry-source-file="PlanPaymentForeignMethod.tsx" />
      <Divider data-sentry-element="Divider" data-sentry-source-file="PlanPaymentForeignMethod.tsx" />
      <Spacing size={32} data-sentry-element="Spacing" data-sentry-source-file="PlanPaymentForeignMethod.tsx" />
      {planTemplateType === PlanTemplateType.PRODUCT_SUBSCRIPTION && <>
          <div className="w-full">
            <h2 className="text-[17px] font-[700] text-gray-900">
              {t('subscription:SpaceDetail.menuManage.virtualCardPaymentMethod', '결제 수단')}
            </h2>
            <Spacing size={14} />
            <div className="flex w-full flex-col items-center">
              <PaypleCardRegisterSection />
            </div>
          </div>
          <Spacing size={32} />
          <Divider />
          <Spacing size={32} />
        </>}
      <TextField label={t('subscription:payment.postalCode.label', '우편번호 (선택)')} data-sentry-element="TextField" data-sentry-source-file="PlanPaymentForeignMethod.tsx">
        <Input {...register('zipCode')} isFullWidth={true} type="number" placeholder={t('subscription:payment.zipCode.placeholder', '우편번호를 입력해주세요')} maxLength={11} data-sentry-element="Input" data-sentry-source-file="PlanPaymentForeignMethod.tsx" />
      </TextField>
    </>;
};